import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DayMonthYearDatePipe } from '../../../../shared/pipes/simple/dayMonthYearDate.pipe';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { PersonGbMasterDetailEntryMeta, PersonGbVersionDetailEntryMeta } from '../../../../core/gb-api';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-persongb-auslaendischerechtsform',
  templateUrl: './persongb-auslaendische-rechtsform.component.html',
  styleUrls: ['./persongb-auslaendische-rechtsform.component.scss'],
  imports: [KopfdatenelementComponent, KompaktTimepointComponent, TranslatePipe, TranslateNamePipe]
})
export class PersongbAuslaendischeRechtsformComponent implements OnInit {
  @Input()
  public version: PersonGbVersionDetailEntryMeta;
  @Input()
  public master: PersonGbMasterDetailEntryMeta;

  constructor(
    public translate: TranslateService,
    public dayMonthYearDatePipe: DayMonthYearDatePipe
  ) {
    keysToTranslate<string>([
      'Personalien',
      'Heimatort',
      'NameDerEltern',
      'NameEhegatte',
      'Geschlecht',
      'Zivilstand',
      'Nationalitaet',
      'Personengruppe',
      'Sprache',
      'Anrede',
      'AHVNummer',
      'AHVVersichertennummer',
      'UidStatus',
      'Gueltig',
      'Adressen'
    ]);
  }

  ngOnInit() {}
}
